module.exports = __webpack_public_path__ + "static/media/Group81.3a2e4510.png";